
import '../assets/css/servicios.css';
import Servicios from '../Componentes/Servicios';
import Galeria from '../Componentes/Galeria';

function trabajos() {
  return (
    <>
      <Servicios/>
      <Galeria/>
    </>

  );
}

export default  trabajos;